/* eslint-disable @typescript-eslint/no-explicit-any */
import { Platform } from '@angular/cdk/platform';
import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { NbDialogService } from '@nebular/theme';
import { Store } from '@ngrx/store';

import { selectUser } from '@app/auth/store/selectors/user.selectors';
import { CommonPwaInstallDialogComponent } from '../modals/common-pwa-install-dialog/common-pwa-install-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class CommonPwaInstallService {
  private readonly dialogService = inject(NbDialogService);
  private readonly platform = inject(Platform);
  private readonly store = inject(Store);

  private readonly userData = toSignal(this.store.select(selectUser));
  //private deferredPrompt: any;

  /*constructor(
  ) {
     setTimeout(() => {
       const dialog = this.dialogService.open(CommonPwaInstallDialogComponent, {closeOnBackdropClick: false, hasBackdrop: false});
     }, 2222);
  }*/

  /*@HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    console.log('[DEFAULT] BEFORE INSTALL PROMPT');
    console.log(e);
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    // e.preventDefault();
    // Stash the event so it can be triggered later.
    this.deferredPrompt = e;

  }*/

  public initAppInstallPrompt(): void {
    // setTimeout(() => {
    if (this.platform.ANDROID) {
      //console.log('[ANDROID]');
      window.addEventListener('beforeinstallprompt', (event: any) => {
        event.preventDefault();
        if (this.userData()) {
          const dialog = this.dialogService.open(CommonPwaInstallDialogComponent,
            {closeOnBackdropClick: false, hasBackdrop: false, context: {device: 'android'}});
          dialog.componentRef.instance.installButtonClicked.subscribe(() => {
            event.prompt();
          });
        }
      });
    }
    if (this.platform.IOS) {
      //console.log('[IOS]');
      if (!this.isInStandaloneMode()) {
        if (this.userData()) {
          this.dialogService.open(CommonPwaInstallDialogComponent,
            {closeOnBackdropClick: false, hasBackdrop: false, context: {device: 'ios'}});
        }
      }
    }
    // }, 1000);
  }

  public isInStandaloneMode(): boolean {
    // @ts-ignore
    return ('standalone' in window.navigator) && (window.navigator.standalone);

  }
}
